import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { InitPluginsOptions } from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { authStoreModule } from '@/views/Auth/store'
import { AUTH_ROUTES } from '@/views/Auth/utils'


const createOnAuthHeader = (store: Store<unknown>) => {
  const { actions, getters } = authStoreModule.context(store)
  let getProfile: Promise<void> | null

  return (hash: string) => {
    // ожидаем последний запрос
    if (getProfile) return getProfile
    const { profileHashSum } = getters
    // при старте profileHashSum еще нет, пропустим т.к. запрос профиля при старте
    if (!profileHashSum || profileHashSum === hash) return void 0

    getProfile = actions.getProfile()
      .finally(() => { getProfile = null })

    return getProfile
  }
}

const createUnauthorized = (router: VueRouter) => {
  const location = {
    name: AUTH_ROUTES.LOGOUT,
    params: { authorized: 'false' },
  }

  return function onUnauthorized() {
    if (router.currentRoute.name === AUTH_ROUTES.LOGIN) return

    void router.push(location)
    // eslint-disable-next-line no-console
      .catch((error) => console.info('[App warn]:', error.message))
  }
}

export const initPlugin = ({ router, store }: InitPluginsOptions) => {
  BaseApiAuth.onAuthHeader = createOnAuthHeader(store)
  BaseApiAuth.onUnauthorized = createUnauthorized(router)
}
